import posthog from 'posthog-js';
import type { TreatmentType, Platform } from '../types';

export function trackSessionStarted(props: {
  treatmentType: TreatmentType;
  durationMinutes: number;
  platform: Platform;
  hasPhaseOverrides: boolean;
}) {
  posthog.capture('session_started', props);
}

export function trackPlaylistGenerated(props: {
  platform: Platform;
  trackCount: number;
  treatmentType: TreatmentType;
  durationMinutes: number;
}) {
  posthog.capture('playlist_generated', props);
}

export function trackPlaybackStarted(props: {
  platform: Platform;
  treatmentType: TreatmentType;
  trackIndex: number;
}) {
  posthog.capture('playback_started', props);
}

export function trackPlaybackPaused(props: {
  platform: Platform;
  currentTrackIndex: number;
}) {
  posthog.capture('playback_paused', props);
}

export function trackTrackSkipped(props: {
  platform: Platform;
  direction: 'next' | 'previous' | 'direct';
  fromIndex: number;
  toIndex: number;
}) {
  posthog.capture('track_skipped', props);
}

export function trackPlaylistSaved(props: {
  platform: Platform;
  treatmentType: TreatmentType;
  trackCount: number;
  durationMinutes: number;
}) {
  posthog.capture('playlist_saved', props);
}

export function trackPlaylistSaveFailed(props: {
  platform: Platform;
  error: string;
}) {
  posthog.capture('playlist_save_failed', props);
}

export function trackPlaylistRegenerated(props: {
  treatmentType: TreatmentType;
  durationMinutes: number;
  platform: Platform;
}) {
  posthog.capture('playlist_regenerated', props);
}

export function trackAppleMusicLinked(props: {
  source: 'session_start' | 'connect_from_preview' | 'preview_start';
}) {
  posthog.capture('apple_music_linked', props);
}
